
import { cn } from "@/lib/utils";
import { Grid, Layers, Image, Lock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export interface CategoryType {
  id: 'scenarios' | 'regions' | 'skin';
  icon: typeof Grid | typeof Layers | typeof Image;
  label: string;
  description?: string;
  disabled?: boolean;
}

interface CategoryTabsProps {
  activeCategory: CategoryType['id'];
  onCategoryChange: (category: CategoryType['id']) => void;
}

export const categories: CategoryType[] = [
  { 
    id: 'scenarios', 
    icon: Grid, 
    label: 'Scenarios',
    description: 'Compatible with AI Analysis & Second Opinion'
  },
  { 
    id: 'regions', 
    icon: Layers, 
    label: 'Regions',
    disabled: true
  },
  { 
    id: 'skin', 
    icon: Image, 
    label: 'Skin',
    disabled: true
  }
];

export function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex border-b border-border/50">
      {categories.map(({ id, icon: Icon, label, disabled }) => (
        <button
          key={id}
          onClick={() => !disabled && onCategoryChange(id)}
          className={cn(
            "flex-1 flex flex-col items-center gap-1 py-3 px-2 text-sm transition-colors relative",
            disabled ? "opacity-70 cursor-not-allowed" : "hover:bg-secondary/50",
            activeCategory === id 
              ? "text-primary border-b-2 border-primary bg-secondary/50" 
              : "text-muted-foreground"
          )}
          disabled={disabled}
        >
          <div className="flex items-center gap-1">
            <Icon className="w-4 h-4" />
            {disabled && <Lock className="w-3 h-3 text-amber-500" strokeWidth={2} />}
          </div>
          <span className="text-xs font-medium">{label}</span>
          {disabled && (
            <Badge 
              variant="outline" 
              className="absolute -top-1 right-1 text-[8px] py-0 px-1.5 bg-amber-50 text-amber-600 border-amber-200"
            >
              Coming Soon
            </Badge>
          )}
        </button>
      ))}
    </div>
  );
}
